import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: _vm.fullscreenLoading,
      expression: "fullscreenLoading",
      modifiers: {
        fullscreen: true,
        lock: true
      }
    }]
  }, [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      border: "",
      "span-method": _vm.objectSpanMethod
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "type",
      label: "类型",
      width: "180"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "desc",
      label: "描述",
      "min-width": "300"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "link",
      width: "180",
      label: "地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [Array.isArray(scope.row.links) ? _c("div", _vm._l(scope.row.links, function (item) {
          return _c("el-link", {
            key: item.name,
            attrs: {
              href: item.url,
              target: "_blank",
              type: item.type
            }
          }, [_vm._v(_vm._s(item.name))]);
        }), 1) : _vm._e()];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };